import React from 'react';

import moment from 'moment';
import { faChevronLeft, faChevronRight } from '@fortawesome/pro-solid-svg-icons';

import ClickableIcon from 'components/clickable_icon';
import { ISO_DATE_FORMAT } from 'helpers/formatters/date_time_formats';

import type { Filters } from './types';

type Slice = Pick<Filters, 'fromDate' | 'toDate'>;
interface Props extends Slice {
  tbd: Filters['tbd'];
  onChange: (changes: Slice) => void;
}

export default function TasksIndexFilters({ fromDate, tbd, onChange }: Props) {
  if (tbd) {
    return null;
  }

  function changeMonth(direction) {
    const newFromMoment = moment(fromDate).add(direction, 'month');
    onChange({
      fromDate: newFromMoment.format(ISO_DATE_FORMAT),
      toDate: newFromMoment.endOf('month').format(ISO_DATE_FORMAT),
    });
  }

  return (
    <div className="d-flex align-items-center mb-3 one-line">
      <ClickableIcon icon={faChevronLeft} onClick={() => changeMonth(-1)} />
      <h3 className="mx-1 my-0">{moment(fromDate).format('MMMM YYYY')}</h3>
      <ClickableIcon icon={faChevronRight} onClick={() => changeMonth(1)} />
    </div>
  );
}
